import {
  ErrorEntity,
  Error as ErrorI,
} from "@/ui-components/utils/root/context";

export const getErrorMessage = async (res: Response) => {
  let errorMessage = "";
  let errorLocation = "";
  let error: ErrorI;
  let isClosable = true;
  let withReload = false;
  let title = "Es ist ein Fehler aufgetreten";
  let redirect = false;
  let buttonText = "Okay";

  try {
    error = (await res.json()) as ErrorI;
  } catch {
    throw new Error("Failed to parse JSON");
  }

  if (!error) {
    throw new Error("Failed to parse JSON");
  }

  if (res.status === 400) {
    errorMessage =
      "400 - Scheinbar scheinen Ihre Angaben nicht ganz korrekt zu sein. Bitte korrigiere das und versuche es nochmals.";
  } else if (res.status === 409) {
    errorMessage =
      "409 - Scheinbar gab es einen Konflikt. Bitte versuche es später nochmals oder kontaktiere den Support.";
  } else if (res.status === 403) {
    errorMessage =
      "403 - Du scheinst nicht die nötigen Rechte zu haben. Bitte kontaktiere den Support oder Ihren Organisationsadministrator.";
  } else if (res.status === 500) {
    errorMessage =
      "500 - Es ist ein Fehler aufgetreten, der nicht auftreten soll. Bitte schreibe dem Support. - Zeitpunkt: " +
      new Date().toLocaleString();
  } else if (res.status === 404) {
    errorMessage =
      "404 - das Objekt wurde nicht gefunden. Bitte versuche es später nochmals oder kontaktiere den Support";
  } else {
    errorMessage = `${res.status} - Es ist ein Fehler aufgetreten. Bitte versuche es später nochmals oder kontaktiere den Support`;
  }

  if (error.error === ErrorEntity.NoOrganizationForbidden) {
    errorLocation = "/register/info";
    error.entity = ErrorEntity.NoOrganizationForbidden;
    redirect = true;
  } else if (error.error === ErrorEntity.UserForbidden) {
    errorLocation = "/";
    error.entity = ErrorEntity.UserForbidden;
    redirect = true;
  } else if (error.error === ErrorEntity.EMailNotVerifiedForbidden) {
    errorLocation = "/verification/mail";
    error.entity = ErrorEntity.EMailNotVerifiedForbidden;
    redirect = true;
  } else if (error.message === "Product with this name or ID already exists") {
    errorMessage =
      "Ein Produkt mit diesem Namen oder ID existiert bereits. Bitte wähle einen anderen Namen oder ID.";
  } else if (error.message === "Pipelines need to be created") {
    errorLocation = "/pipelines/create";
    errorMessage =
      "Es müssen zuerst Pipelines erstellt werden, bevor Deals aufgerufen werden können. Als Vertriebspartner kontaktiere bitte einen Administrator!";
    buttonText = "Pipelines erstellen";
  } else if (error.message === "User is not permitted for any pipeline") {
    errorMessage =
      "Sie sind noch keiner Pipeline zugewiesen. Bitte wenden Sie sich an Ihren Administrator (z.B. Dirk Bienert), um Zugriff auf eine Verkaufspipeline zu erhalten.";
  } else if (error.message === "No active sales rank found") {
    errorMessage =
      "Es wurde keine aktiver Sales Rank gefunden. Bitte erstelle einen Sales Rank und aktiviere diesen.";
    buttonText = "Sales Rank erstellen";
    errorLocation = "/settings/sales-ranks/create";
  } else if (
    error.message === "Another product is already set as basic security"
  ) {
    errorMessage =
      "Es existiert bereits ein Produkt, welches als Grundabsicherung gesetzt ist.";
  } else if (error.message === "Cannot archive user with subordinate users") {
    errorMessage =
      "Ein Benutzer mit untergeordneten Benutzern kann nicht archiviert werden.";
  } else if (
    error.message === "Cannot unset hierarchy, user has subordinate users"
  ) {
    errorMessage =
      "Ein Benutzer mit untergeordneten Benutzern kann nicht deine Hierarchie entfernt werden.";
  } else if (
    error.message ===
    "Cannot assign user to sales rank, a subordinate user is already assigned to this sales rank"
  ) {
    errorMessage =
      "Ein untergeordneter Benutzer ist bereits diesem Vertriebsrang zugewiesen.";
  } else if (error.message === "User is not allowed to create a sale") {
    errorMessage =
      "Du hast nicht die nötigen Rechte, um eine Verkaufsposition zu erstellen.";
  } else if (error.message === "Sale is not editable") {
  } else if (error.message === "Pipeline with this title already exists") {
    errorMessage =
      "Eine Pipeline mit diesem Namen existiert bereits. Bitte wähle einen anderen Namen.";
  } else {
    errorMessage =
      "Es ist ein Fehler aufgetreten. Bitte versuche es später nochmals oder kontaktiere einen Administrator";
  }

  const parsedError: ErrorI = {
    message: errorMessage,
    error: error.error,
    statusCode: res.status,
    entity: error.entity,
    location: {
      path: errorLocation,
      redirect,
      buttonText,
    },
    isClosable,
    withReload,
    title,
    mail: error.mail,
  };

  return parsedError;
};
